// extracted by mini-css-extract-plugin
export default {"dropzone":"qB7yu","burnInLogo":"be1Ai","tabsContainer":"TuED8","fileTypes":"YmuZC"};